import { default as classnames } from 'classnames';
import { useEffect, useState } from 'react';

const DEFAULT_DURATION_MS = 1600;
const DEFAULT_HEIGHT = 20;
const DEFAULT_WIDTH = 96;

export type ShimmerProps = {
    isLoading: boolean;
    height: number;
    width: number;
    className?: string;
    duration?: number;
    children?: React.ReactNode | string;
};

const calcShimmerStyle = (width: number, height: number, duration = DEFAULT_DURATION_MS) => ({
    backgroundSize: `${width * 10}px ${height}px`,
    animationDuration: `${(duration / 1000).toFixed(1)}s`,
});

export const Shimmer = ({
    isLoading,
    height = DEFAULT_HEIGHT,
    width = DEFAULT_WIDTH,
    className,
    duration = DEFAULT_DURATION_MS,
    children,
}: ShimmerProps) => {
    const shimmerStyle = calcShimmerStyle(width, height, duration);
    const style = { ...shimmerStyle, ...{ height, width } };

    const [hasLoaded, setHasLoaded] = useState(isLoading);
    useEffect(() => {
        if (!isLoading) {
            setHasLoaded(true);
        }
    }, [isLoading]);

    return !hasLoaded ? (
        <div className={classnames('shimmer rounded-md', className)} style={style} />
    ) : (
        <div className={className}>{children}</div>
    );
};
Shimmer.defaultProps = {
    duration: DEFAULT_DURATION_MS,
    height: DEFAULT_HEIGHT,
    width: DEFAULT_WIDTH,
};
